import React,{ useEffect, useState, useRef } from 'react';
import {Divider, Table, Popconfirm, Card, Switch, Input, Button, Tag, Row, Col, Drawer} from 'antd';
import {CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link } from 'react-router-dom';

import { ExitActionForm } from '@gtpl/pages/hrms/hrms-components/exit-action-form';
import { ExitActionDto } from '@gtpl/shared-models/hrms';
import { ExitActionService } from '@gtpl/shared-services/hrms';
import { HrmsEmployeeDetailsDto, HrmsEmployeeRequest} from '@gtpl/shared-models/masters';
import {HrmsEmpDetService} from '@gtpl/shared-services/masters';

import moment from 'moment';

import './exit-action-grid.css';
import { exit } from 'process';

/* eslint-disable-next-line */
export interface ExitActionGridProps {}

export function ExitActionGrid(
  props: ExitActionGridProps
) {
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [exitActionData, setExitActionData] = useState<ExitActionDto[]>([]);
  const [selectedExitAction, setSelectedExitAction] = useState<any>(undefined);

  const hrmsEmpDetService = new HrmsEmpDetService();

  const exitActionService = new ExitActionService();

  useEffect(() => {getAllExitActions();},[]);

  const getAllExitActions= () => {
    exitActionService.getAllExitActions().then(res => {
      if(res.status){
        console.log(res.data)

        
        // res.data.forEach((exitAction)=>{
        //   const req = new HrmsEmployeeRequest(exitAction.employeeId);
        //   hrmsEmpDetService.getActiveEmployeesById(req).then(res =>{
        //     exitAction.employeeName = res.data.employeeName;
        //   })
        //   const req1 = new HrmsEmployeeRequest(exitAction.approvedBy);
        //   hrmsEmpDetService.getActiveEmployeesById(req1).then(res =>{
        //     let approvedBy:any=res.data.employeeName;
        //     exitAction.approvedBy = approvedBy;
        //   })
          
        // });
        setExitActionData(res.data);
        AlertMessages.getSuccessMessage('Exit Actions Retrieved Successfully')
      } else {
        if(res.intlCode) {
          setExitActionData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setExitActionData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const updateExitAciton = (exitActionData: ExitActionDto) => {
    exitActionService.updateExitAction(exitActionData).then(res => {
      if(res.status){
        AlertMessages.getSuccessMessage('Updated Successfully');
        getAllExitActions();
        setDrawerVisible(false);
      }else {
        if(res.intlCode){
          AlertMessages.getErrorMessage(res.internalMessage);
        }else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const deleteExitAction = (exitAction: ExitActionDto) => {
    exitAction.isActive = exitAction.isActive ? false : true;
    exitActionService.activateOrDeactivateExitAction(exitAction).then(res =>{
      if(res.status){
        getAllExitActions();
        AlertMessages.getSuccessMessage('Success');
      }else {
        if(res.intlCode){
          AlertMessages.getErrorMessage(res.internalMessage);
        }else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  /**
   * used for column filter
   * @param dataIndex column data index
   */
   const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
  */
   function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  //drawer related
  const closeDrawer=()=>{
    setDrawerVisible(false);
  }
  
  const openFormWithData = (viewData: ExitActionDto) => {
    setDrawerVisible(true);
    console.log(viewData)
    setSelectedExitAction(viewData);
    console.log(selectedExitAction);
    console.log('selectedExitAction');
    viewData.exitDate=moment(viewData.exitDate, 'YYYY-MM-DD')
  }

  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: 'Exit Date',
      key: 'exitDate',
      sorter: (a, b) => moment(a.exitDate).unix() - moment(b.exitDate).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return moment(record.exitDate).format('YYYY-MM-DD') },
    },
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      responsive: ['sm'],
       sorter: (a, b) => String(a.employeeCode)?.localeCompare(b.employeeCode),
       sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('employeeCode'),   
    },
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
      sorter: (a, b) => a.employeeName?.localeCompare(b.employeeName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('employeeName')
    },
    
    {
      title: 'Exit Reason',
      dataIndex: 'exitReason',
      sorter: (a, b) => a.exitReason.localeCompare(b.exitReason),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('exitReason') 
    },
    // {
    //   title: 'Remarks',
    //   dataIndex: 'remarks',
    //   responsive: ['sm'],
    //   // responsive: ['lg']...getColumnSearchProps('remarks')
    // },
    {
      title: 'Approved By',
      dataIndex: 'approvedBy',
      sorter: (a, b) => String(a.approvedByName)?.localeCompare(b.approvedByName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('approvedByName') ,
      render: (text, data, index) => {
        return <span>{data.approvedByName}</span>
      }
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'isActive',
    //   render: (isActive, rowData) => (
    //     <>
    //       {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          
    //     </>
    //   ),
    //   filters: [
    //     {
    //       text: 'Active',
    //       value: true,
    //     },
    //     {
    //       text: 'InActive',
    //       value: false,
    //     },
    //   ],
    //   filterMultiple: false,
    //   onFilter: (value, record) => 
    //   {
        
    //     return record.isActive === value;
    //   },
      
    // },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>         
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Exit Action');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
           
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{deleteExitAction(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate exit-action ?'
                :  'Are you sure to Activate exit-action ?'
            }
          >
            
          </Popconfirm>
       </span>
      )
    }
  ];

  /**
     * 
     * @param pagination 
     * @param filters 
     * @param sorter 
     * @param extra 
     */
   const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  const OpenFormTocreateRecord = () => {
   console.log('redirect here');
   
  }

  return (
    <Card title={<span style={{color:'white'}}>Exit Actions</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/exit-action-form' ><Button className='panel_button' >Create </Button></Link>}
    
    >
     <br></br>
     <Row gutter={40}>
      
          </Row>
          <br></br>
          <Table
          rowKey={record => record.exitActionId}
          columns={columnsSkelton}
          dataSource={exitActionData}
          scroll = {{x:true}}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <ExitActionForm
                updateExitAction={updateExitAciton}
                isUpdate={true}
                exitActionData={selectedExitAction}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
     </Card>
  );
}

export default ExitActionGrid;